module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/section05_01_american-village-8964feb9df77be50c2a686bf72803c9f.jpg";